import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/button/Button';
import Select from '../../components/select/Select';
import { useTranslation } from '../../context/translationContext';
import { paths } from '../../pages/RouterContainer';
import { Team } from '../../types/Team';
interface Props {
  teams: Team[];
  onAssign: (selectedTeam: Team) => void;
}

/**
 * Component for Assigning teams to selected / current company
 */
export const CompanyTeamAssignForm = ({ teams, onAssign }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedTeam, setSelectedTeam] = useState<Team>(teams[0]);

  /**
   * Assignes team to company
   */
  const handleAssignTeam = () => {
    onAssign(selectedTeam);
  };

  /**
   * Redirects to Create team page
   */
  const handleCreateNewTeam = () => {
    navigate(`/${paths.MY_TEAMS}/create`);
  };

  return (
    <div className="grid ">
      <div className="inline-flex items-center">
        <div>
          <Select
            data={teams}
            minWidth={180}
            value={selectedTeam}
            onChange={(e) => setSelectedTeam(e)}
            labelKey="name"
          />
        </div>
        <div>
          <Button
            title={t('page.team.assign-team')}
            onClick={handleAssignTeam}
            className="ml-2 mr-2"
            color="green"
            showLoading
          />
          <Button title={t('page.team.new-team')} onClick={handleCreateNewTeam} color="blue" />
        </div>
      </div>
    </div>
  );
};
